import { render } from "./BorrowHistoryView.vue?vue&type=template&id=b43f8e60"
import script from "./BorrowHistoryView.vue?vue&type=script&lang=js"
export * from "./BorrowHistoryView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__